/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CleApiDto } from '../models/cle-api-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des clés api
 */
@Injectable({
  providedIn: 'root',
})
export class ClesApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cleApiGetList
   */
  static readonly CleApiGetListPath = '/api/cles-api/list';

  /**
   * Renvoie la liste des clés d'API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CleApiDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CleApiDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des clés d'API.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiGetList(params?: {
  }): Observable<Array<CleApiDto>> {

    return this.cleApiGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CleApiDto>>) => r.body as Array<CleApiDto>)
    );
  }

  /**
   * Path part for operation cleApiLoadList
   */
  static readonly CleApiLoadListPath = '/api/cles-api/load-list';

  /**
   * Renvoie la liste des clés d'API (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des clés d'API (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.cleApiLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation cleApiGet
   */
  static readonly CleApiGetPath = '/api/cles-api/{id}';

  /**
   * Renvoie la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiGet$Response(params: {

    /**
     * Identifiant de la clé d&#x27;API
     */
    id: number;
  }): Observable<StrictHttpResponse<CleApiDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CleApiDto>;
      })
    );
  }

  /**
   * Renvoie la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiGet(params: {

    /**
     * Identifiant de la clé d&#x27;API
     */
    id: number;
  }): Observable<CleApiDto> {

    return this.cleApiGet$Response(params).pipe(
      map((r: StrictHttpResponse<CleApiDto>) => r.body as CleApiDto)
    );
  }

  /**
   * Path part for operation cleApiPut
   */
  static readonly CleApiPutPath = '/api/cles-api/{id}';

  /**
   * Met à jour la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiPut$Response(params: {

    /**
     * Identifiant de la clé d&#x27;API
     */
    id: number;

    /**
     * Clé d'API
     */
    body: CleApiDto
  }): Observable<StrictHttpResponse<CleApiDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CleApiDto>;
      })
    );
  }

  /**
   * Met à jour la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiPut(params: {

    /**
     * Identifiant de la clé d&#x27;API
     */
    id: number;

    /**
     * Clé d'API
     */
    body: CleApiDto
  }): Observable<CleApiDto> {

    return this.cleApiPut$Response(params).pipe(
      map((r: StrictHttpResponse<CleApiDto>) => r.body as CleApiDto)
    );
  }

  /**
   * Path part for operation cleApiDelete
   */
  static readonly CleApiDeletePath = '/api/cles-api/{id}';

  /**
   * Supprime la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiDelete$Response(params: {

    /**
     * Identifiant de la clé d&#x27;API à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cleApiDelete(params: {

    /**
     * Identifiant de la clé d&#x27;API à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.cleApiDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation cleApiPost
   */
  static readonly CleApiPostPath = '/api/cles-api';

  /**
   * Crée la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cleApiPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiPost$Response(params: {

    /**
     * Clé d'API
     */
    body: CleApiDto
  }): Observable<StrictHttpResponse<CleApiDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClesApiService.CleApiPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CleApiDto>;
      })
    );
  }

  /**
   * Crée la clé d'API spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cleApiPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cleApiPost(params: {

    /**
     * Clé d'API
     */
    body: CleApiDto
  }): Observable<CleApiDto> {

    return this.cleApiPost$Response(params).pipe(
      map((r: StrictHttpResponse<CleApiDto>) => r.body as CleApiDto)
    );
  }

}
